import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
export const ConversationIcon = ChatBubbleLeftRightIcon;
